import { ComunicacionAjax } from "@/ts/api/comunicacion";
import { useQuery, type QueryClient } from "@tanstack/react-query";

export function getArticuloByReference(referenciaArticulo: string): Promise<MaybeArticulo> {
	const parametro = {
		"referencia": referenciaArticulo,
	};

	const url = "/api/v1/getDatosArticulo";
	return ComunicacionAjax.sendAjaxRequest<MaybeArticulo>("GET", url, parametro);
}
export interface InfoArticulo {
	id: number,
	descripcion: string,
	referencia: string,
	peso: number,
	controlaLotes: boolean,

	nombreFamilia: string,
}
type MaybeArticulo = (InfoArticulo & { exists: true; }) | { exists: false; };



export async function refreshArticuloConKit(idArticulo: number, queryClient: QueryClient): Promise<void> {
	const url = "/api/v1/articuloConKit";
	const parametro = { idArticulo };
	const kit = await ComunicacionAjax.sendAjaxRequest<ArticuloKit>("GET", url, parametro);

	const oldVals = queryClient.getQueryData<ArticuloKit[]>(["articulosConKits"]);
	if (oldVals) {
		const newVals = [...oldVals];
		const index = newVals.findIndex(art => art.idArticulo === idArticulo);
		if (index !== -1) {
			newVals[index] = kit;
			queryClient.setQueryData(["articulosConKits"], newVals);
		}
	}
}


export function useArticulosKits() {
	return useQuery<ArticuloKit[]>({
		queryKey: ["articulosConKits"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<ArticuloKit[]>("GET", "/api/v1/articulosConKits", {});
		}
	});
}

export interface ArticuloKit {
	idArticulo: number;
	descArticulo: string;
	referencia: string;
	descripcionFamilia: string | null;
	idFamilia: number | null;
	componentes: KitComponente[] | null;
}

export interface KitComponente {
	idComponente: number,
	refComponente: string,
	descComponente: string,
	cantidadPorUnidad: number;
	cantidadDivisor: number;
}

export function useArticuloKit(idArticulo: number | null) {
	return useQuery<ArticuloKit>({
		queryKey: ["kitArticulo", idArticulo],
		queryFn: () =>
			ComunicacionAjax.sendAjaxRequest<ArticuloKit>("GET", "/api/v1/articuloConKit", {
				idArticulo: idArticulo,
			}),
		enabled: idArticulo !== null,
	});
}